export default {
    customer: "Customer",
    account_number: "Register Number",
    dashboard: "Dashboard",
    customers: "Walking Customers",
    externals: "Walking Customers",
    daily_transactions: "Transactions",
    sailors: "Sailors",
    branchs: "Branches",
    branches_and_agents: "Branches/Agents",
    staffs: "Staffs",
    banks: "Banks",
    staff: "Staff",
    income: "Income",
    incomes: "Incomes",
    shareholders: "Shareholders",
    shareholder: "Shareholder",
    expense: "Expense",
    expenses: "Expenses",
    branch_accounts: "Agency Accounts",
    report: "Report",
    reports: "Reports",
    company_report: "Company's Report",
    settings: "Settings",
    male: "Male",
    female: "Female",
    single: "Single",
    married: "Married",
    users: "Users",
    role: "Role",
    roles: "Roles",
    user: "User",
    all_settings: "General Settings",
    date: "Date",
    payment_type: "Payment Type",
    transaction_no: "Transaction",
    credit: "Credit",
    credits: "Receipts",
    credit_number: "Receipt Number",
    debit: "Debit",
    debits: "Payments",
    debit_number: "Payment Number",

    exchange: "Exchange",
    exchanges: "Exchanges",
    exchanger: "Exchanges",
    exchange_number: "Exchange Number",

    to: "To",
    from: "From",
    transfer: "Transfer",
    form_number: "Form Number",
    transfers: "Transfers",
    transfer_src: "Transfer Source",
    send_transfer: "Send Remittance",
    submit_transfer: "Remittance Paid",
    transfer_number: "Transfer Number",
    send_transfers: "Send Remittance",
    transfer_not_done: "Not Paid",
    transfer_done: "Paid",
    receive_transfers: "Receive Remittance",
    receive_transfer: "Receive Remittance",

    balance: "Balance",
    balance_summery: "Summary",
    number: "No",
    other_currencies: "Other Currencies",
    description: "Remarks",
    amount: "Amount",
    total: "Total",
    money_type: "Money Type",
    rate: "Rate",
    exchange_rate: "Exchange Rate",
    old_balance: "Old Balance",
    current_balance: "Current Balance",
    return: "Return",
    new_record: "New Record",
    edit_record: "Edit Record",
    search: "Search",
    contact: "Contact",
    agency: "Branch",
    agencies: "Branches",
    actions: "Actions",
    name: "Name",
    middle_name: "Middle Name",
    first_name: "First Name",
    last_name: "Last Name",
    backup: "Backups",
    save_succeed: "Operation done successfully.",
    wrong_input: "Please verify inputs!",

    daily_rate: "Daily Rate",
    new_daily_rate: "New Rate",
    password: "Password",
    old_password: "Current Password",
    new_password: "New Password",
    accept_password: "Confirm Password",
    account: "Account",
    accounts: "Accounts",
    account_name: "Account Name",
    new_account: "New Account",
    debited_account: "Debited Account",
    type: "Type",
    action_type: "Action",
    c2c: "Customer Transfer",
    cash: "Cash",
    bank: "Bank",
    sail_money: "Sail Money",
    buy_money: "Purchase Money",
    borrow_total: "Total Borrow",
    loan_total: "Total Loan",
    cash_accounts: "Cash In Hand",
    bank_accounts: "Bank Accounts",
    part: "Part",
    commissions: "Commissions",
    commission: "Commission",
    view: "View",
    edit: "Edit",
    add: "Add",
    delete: "Delete",
    customer_account: "Customer's Account",
    receiver_account: "Receiver's Account",
    sender_account: "Sender's Account",
    receiver: "Receiver",
    sender: "Sender",
    branch_account: "Agency Account",
    father_name: "Father Name",
    identity_number: "Identity Number",
    occupation: "Occupation",
    exchange_to: "Exchange To",
    sailor: "Sailor",
    edit_bill: "Edit Bill",
    status: "Status",
    currency: "Currency",
    currencies: "Currencies",
    currency_worth: "Currency Rank",
    from_date: "From Date",
    to_date: "To Date",
    profile: "Profile",
    id: "ID",
    history: "History",
    costs: "Expenses",
    email: "Email",
    address: "Address ",
    //customers
    delete_title: "Delete Record",
    delete_alert: "Are you sure you want to delete selected records?",
    delete_succeed: "Items deleted successfully. ",
    save: "Save",
    personal_info: "Personal Info",
    title: "Title",
    //================================================================
    company: "Company",
    companies: "Companies",
    pure_profits: "Net Profits",
    current_money: "Inhand Cash",
    company_financial_report: "Financial Report",
    login: "Login",
    logout: "Logout",
    backups: "Backups",
    file: "File",
    size: "Size",
    old_rate: "Old Rate",
    current_rate: "Current Rate",
    rate_incomes: "Rate Incomes",
    daily_profits: "Daily Profits",
    updated_at: "Last Update",
    sale_currency: "Sale CCY",
    buy_currency: "Purchase CCY",
    action: "Action",
    rate_table: "Rates",
    received_money_type: "Received Currency",
    a2a_transfers: "A2A Transfers",
    transaction_transfers: "Transfers",
    credit_amount: "Credited Amount",
    debit_amount: "Debited Amount",
    exchange_amount: "Exchanged Amount",
    transfer_amount: "Transferd Amount",
    stock: "Stock",
    gam: "Creditor",
    baqi: "Debtor",
    currency_loan: "Debtors",
    last_form_number: "Last Transaction",
    bill_number: "Bill#",
    cleared: "Cleared",
    forgot_password: "Forgot your password?",
    login_error: "Incorrect username or password.",
    tazkira: "Tazkira/Passport details",
    new_customer: "New Customer",
    external_customer: "Walking Customer",
    date_of_birth: "Date Of Birth",
    place_of_birth: "Place of Birth",
    nationality: "Nationality",
    gender: "Gender",
    marital_status: "Marital Status",
    permanent_address: "Permanent Address",
    current_address: "Current Address",
    official_address: "Official Address",
    phones: "Phones",
    nature_of_business: "Nature Of Business",
    monthly_income: "Monthly Income",
    source_of_income: "Source of Income",
    monthly_turnover: "Monthly Turnover",
    tazkira_no: "Tazkira No",
    passport_no: "Passport No",
    issuer_place: "Issuer Place",
    issue_date: "Issue Date",
    expire_date: "Expire Date",
    tin_number: "TIN Number",
    tenure: "Tenure",
    current_designation: "Current Designation",
    previous_designation: "Previous Designation",
    risk_profile: "Risk Profile",
    kyc_notes: "Interview Remark (KYC Notes)",
    next_kyc_date: "Next KYC Date",
    kyc_updated_date: "KYC Updated Date",
    reg: "REG",
    reg_no: "Reg No",
    reg_date: "Reg Date",
    personal_details: "Personal Details",
    resident_status: "Resident Status",
    resident: "Resident",
    non_resident: "Non-Resident",
    contact_details: "Contact Details",
    profession_details: "Profession Details",
    individuals: "Individuals",
    corporates: "Corporates",
    corporate_details: "Corporate Details",
    area_of_services: "Area of Services",
    corporate_name: "Corporate/Business Name",
    business_address: "Business Address",
    domicile_address: "Domicile Address",
    license_no: "License No",
    contact_person_name: "Contact Name",
    director: "Shareholder",
    directors: "Shareholders",
    established_date: "Established Date",
    corporate_type: "Business Type",
    license_issue_date: "License Issue Date",
    license_expire_date: "License Expire Date",
    contact_person_details: "Contact Person Details",
    incorporation: "Incorporation",
    incorporation_date: "Incorporation Date",
    reg_address: "Registrar Address",
    company_phones: "Company Phone Numbers",
    company_email: "Company Email",
    designation: "Designation",
    reg_name: "Reg Name",
    add_director: "Add Director",
    tazkira_no_or_p: "Tazkira / Passport",
    cif: "Customer Information",
    individual_cif_title: "Indvidual Customer Registeration :",
    receipt_form: "Cash Receipt Form",
    tr: "TrNo",
    units: "Units",
    total: "Total",
    time: "Time",
    no: "No",
    cash_receipt_form: "Cash Receipt Form ",
    cash_receipts: "Cash Receipts",
    cash_receipt_title: "Cash receipt voucher for the purpose of Exchange/Remittence",
    cash_payments: "Cash Payments",
    cash_payment_form: "Cash Payment Form",
    cash_payment_title: "Cash payment voucher for the purpose of Exchange/Remittence",
    exchange_form: "Exchange Form",
    exchanged_amount: "Exchanged Amount",
    full_name: "Full Name",
    doc_type: "Document Type",
    doc_no: "Document Number",
    purpose_of_exchange: "Purpose of Exchange",
    source_of_fund: "Source of Fund",
    exchange_bill_title: "Exchange Slip",
    sale_account: "Sale Account",
    buy_account: "Purchase Account",
    docno: "Doc No",
    file_max_notation: "The file size should be less than 10 Mb",
    files: "Files",
    passport: "Passport",
    tazkira: "Tazkira",
    license: "License",
    a2a_transfer_slip: "Account to Account Slip",
    a2a_form: "Account to Account Transfer",
    send_remittance_form: "Send Remittance Forms",
    receive_remittance_form: "Receive Remittance Forms",
    relationship: "Relationship to Receiver",
    purpose_of_transaction: "Purpose of Transaction",
    sender_details: "Sender's Details",
    receiver_details: "Receiver's Details",
    source: "Source",
    destination: "Destination",
    destination_currency: "Destination currency",
    sender_currency: "Sender currency",
    receiver_currency: "Receiver Currency",
    remittance_details: "Remittance Details",
    send_transfer_slip: "Send Remittance Slip",
    receive_transfer_slip: "Receive Remittance Slip",
    RefNo: "RefNo",
    receiver_address: "Receiver Address",
    branches: "Branches",
    received_transfers: "Received Remittance",
    system_accounts: "Agency Accounts",
    incomes: "Incomes",
    transaction_details: "Transcation Details",
    received_account: "Received Account",
    customer_details: "Customer Details",
    general_ledger: "General Ledger",
    lctr_report: "LCTR Reports",

    unauthorized_route: "Sorry! you are not allowed to access this route.",
    notfound_route: "Sorry! there is no such route.",
    go_back: "Go Back",
    view_accounts: "View Accounts",
    change_rate: "Update Rate",
    registration: "Registration",
    remittance: "Remittance",
    remittances: "Remittances",
    paid_account: "Paid Account",
    start_date: "Start Date",
    code: "Code",
    branch: "Branch",
    end_date: "End Date",
    branch_code: "Branch Code",
    corporates_report: "Corporates Report",
    individuals_report: "Individuals Report",
    corporates_report: "Corporates Report",
    individuals_report: "Individuals Report",
    exchanges_report: "Exchanges Report",
    shareholder: "Shareholder",
    shareholders: "Shareholders",
    other_branches: "Other Branches",
    income_statement: "Income Statement",
    balance_sheet: "Balance Sheet",
    exchanges_profit: "Exchange's Profit",
    commissions_profit: "Commission's Profit",
    sale_to_base_rate: "Sale CUR USD Rate",
    buy_to_base_rate: "Purchase CUR USD Rate",
    profit: "Profit",
    amount_in_word: "Amount In Word",
    commission_in_word: "Commission In Word",
    avg_rate: "AVG Rate",
    system: "Cash", // Just for Account type
    liability: "Liability",
    equity: "Equity",
    asset: "Asset",
    capital: "Capital",
    account_group: "AC Group",
    net_income: "Income",
    base_rate: "Default Rate to USD",
    view_all_branches_report: "All Branches Report",
    transactions_report: "Transaction's Report",
    deleted_at: "Deleted At",
    avr_exchanged: "AVR Exchagned",
    received_by: "Received By",
    total_debit: "Total Debits",
    total_credit: "Total Credits",
    available_balance: "Available Balance",
    new_customer: "New Customer",
    disable_back_date: "Disable Back Date",
    account_to_search: "Account's Balance",
    app_shortcuts: "Application Shortcuts",
    payables: "Payables",
    receiveables: "Receiveables",
    expose_report: "Expose Report",
    exposed_amount: "Total Exposed",
    opening_balance: "Opening Balance",
    persian_date: "Hijri Date",
    accounts_balance: "Accounts Balance",
    external: "Walking Customer",
    individual: "Indvidual",
    corporate: "Corporate",
    closing_balance: "Closing Balance",
    full_details: "Full Details",
    fa_name: "Name in FA",
    locked_until: "Locked Until",
    buy_currency_details: "Purcahse Currency Details",
    sale_currency_details: "Sale Currency Details",
    no_transaction_found: "No Transaction Found",
    ccif: "Corporate Customer Information Form (CCIF)",
    icif: "Individual Customer Information Form (ICIF)",
    customer_sign: "Customer's Signature",
    cashire_sign: "Cashire's Signature",
    approved_by: "Approved By",
    corporate_reg_form: "Corproate Customer Registeration",
    unsave_alert: "You have unsaved changes! Do you want to leave the page?",
    delete_record: "Delete Record",
    credit_description: "Money receipt from ",
    debit_description: "Money paid to ",
    into: "In to",
    buy: "Purchase",
    sale: "Sale",
    rate_of: "at rate of",
    transfered_from: "Transfered from",
    transfered_to: "to",
    all: "All",
    deleted: "Deleted Trs",
    all_currencies: "All Currencies",
    total_assets: "Total Assets",
    total_liabilities: "Total Liabilities",
    purchase_amount: "Purchase Amount",
    sale_amount: "Sale Amount",
    cic: "ALL CCI",
    credit_description: "To Customer Account",
    from_sender: "On behalf of",
    to_receiver: "to",
    with_amount_of: "in the amount of",
    with_transafer_no: "with TR number",
    total_income: "Total Incomes",
    total_expense: "Total Expenses",
    afn_equalient: "AFN Equivalent",
    usd_equalient: "USD Equivalent",
    branches_receivables: "Branches Receivables",
    branches_payables: "Branches Payables",
    individuals_receivables: "Individuals Receiveables",
    individuals_payables: "Individuals Payables",
    customers_receivables: "Customers Receivables",
    customers_payables: "Customers Payables",
    corporates_receivables: "Corporates Receivables",
    corporates_payables: "Corporates Payables",
    shareholders_payables: "Shareholders Payables",
    transferred_to: "Transferred to",
    view_dashboard: "View Dashboard",
    delete_files: "Delete Files",

    ccif: "Corporate Customer Information Form (CCIF)",
    icif: "Individual Customer Information Form (ICIF)",
    customer_sign: "Customer's Signature",
    cashire_sign: "Cashire's Signature",
    approved_by: "Approved By",
    corporate_reg_form: "Corproate Customer Registeration",
    unsave_alert: "You have unsaved changes! Do you want to leave the page?",
    delete_record: "Delete Record",
    credit_description: "Money receipt from ",
    debit_description: "Money paid to ",
    into: "In to",
    buy: "Purchase",
    sale: "Sale",
    rate_of: "at rate of",
    transfered_from: "Transfered from",
    transfered_to: "to",
    all: "All",
    deleted: "Deleted Trs",
    all_currencies: "All Currencies",
    total_assets: "Total Assets",
    total_liabilities: "Total Liabilities",
    purchase_amount: "Purchase Amount",
    sale_amount: "Sale Amount",
    cci: "CCI",
    account_statement_of: "Account Statement of",
    balance_sheet_of: "Balance sheet of",
    with: "with",
    business_name: "Company Name",
    view_dashboard: "View Dashboard",
    delete_files: "Delete Files",
    save_print: "Save & Print",
    position: "Position",
    hire_date: "Hire Date",
    fire_date: "Fire Date",
    salary: "Salary",
    exchange_results: "Exchange Results",
    refresh: "Refresh",
    print: "Print",
    excel: "Excel File",
    full_details_of_receiver: "Full Details of Receiver",
    full_details_of_sender: "Full Details of Sender",
    sender_full_name: "Sender Full Name",

    received_commission: "Received Commission",
    paid_commission: "Paid Commission",
    received_transfer_number: "Received TrNo",
    receive: "Receive",
    send: "Send",
    a2a: "A2A",
    percentage: "Percentage",
    deactivated: "Deactivated",
    business_name: "Business Name",
    account_statement: "Account Statment",
    exchange_income_report: "Exchange Incomes",
    sale_profit: "Sale Profit",
    buy_profit: "Buy Profit",
    maximum_amount: "Maximum Amount",
    minimum_amount: "Minimum Amount",
    saraf: "Agent",
    sarafs: "Agents",
    exteranl_accounts: "External Accounts",
    assets: "Assets",
    fixed_assets: "Fixed Assets",
    sarafs_commission: "Agent's Commission",
    gov_id: "Gov-ID",
    customer_type: "Customer Type",
    establishment_date: "Establishment Date",
    transactions_count: "Transactions(Per Month)",
    transactions_amount: "Inward/Outward (Per Month)",
    links: "Links",
    risk_category: "Risk Category",
    suction_checked: "Sanction Screening Checked",
    organization_chart: "Organization Chart",
    share_amount: "Share Amount",
    is_dab: "Dab Auction",
    sign: "Sign",
    pep: "PEP",
    str: "STR",
    sanction_screening: "Sanction Screening",
    dab_auction: "DAB Auctions Result",
    position_rank: "Position Rank",
    join_date: "Join Date",
    resign_date: "Leave Date",
    print_org_chart: "Print Organization Chart",
    temporary: "Temporary Customer",
    share_percentage: "Share Percentage",
    staff_reg: "Staff Registeration and Organization Chart",
    total_cash_with_banks: "Total Cash With Banks",
    individuals_receivables: "Individuals Receivables",
    individuals_payable: "Individuals Payable",
    customers_receivables: "Customers Receivables",
    customers_payable: "Customers Payable",
    staffs_advance_salary_receivables: "Staffs Advance Salary Receivables",
    staffs_salary_payable:"Staffs Salary Payable",
    sarafs_receivables:"Sarafs Receivables",
    sarafs_payable:"Sarafs‌ Payable",
    sarafs_com_receivables:"Sarafs Com Receivables",
    sarafs_com_payable:"Sarafs Com Payable",
    corporates_receivables:"Corporates Receivables",
    corporates_payable:"Corporates‌ Payable",
    shareholders_payable:"Shareholders Payable",
    net_income:"Net‌ Income",
    income:"Income",
    branch_payable:"Account Payables (Inter branch account)",
    branch_receivables:"Account Receivables (Inter branch account)",
    "Cash In Hand":"Cash In Hand",
    "Commission Incomes":"Comission Incomes",
    "Exchange Incomes":"Exchange Incomes",
    income_statement_from:"Income statement from",
    notification_report:"Transactions Notification",
    customers_overbalanced:"Customers over balanced",
    other_liabilities:"Other Liabilites",
    current_assets:"Current Assets",
    total_current_assets:"Total Current Assets",
    total_fixed_assets:"Total Fixed Assets",
    current_liabilities:"Current Liabilities",
    total_capital:"Total Capital",
    capital_and_liabilities:"Capital & Liabilities",
    all_branches:"All Branches",
    permanent:"Permanent Customer",
    status:"Status",
    view_chart:"View Organization Chart",
    compliance_sign:"Compliance Sign",
    low:"Low",
    medium:"Medium",
    high:"High",
    non_lctr_report:"Non LCTR Report",
    alctr_report:"A LCTR Report",
    links:"Links",
    purpose_of_transaction:"Purpose of Transaction",
    for_send_remittance:"For Send Remittance",
    for_exchange:"For Exchange",
    for_others:"Others",
    low_balance_alert:"Low Balance Alert",
    confirm_low_balance:"Balance is negative. Are you sure you want to confirm low balance?",
    confirm:"Confirm",
    cancel:"Cancel",
    close:"Close",
};
